import { connect } from 'react-redux';

import { getIsAdmin } from 'src/store/client/selectors';
import {
  getOperatorName,
  getBookingUrl,
  getOperatorSearchUrl,
} from '../../store/selectors/package';
import OperatorInfo from './OperatorInfo';

const mapStateToProps = (state) => ({
  operatorName: getOperatorName(state),
  bookingUrl: getBookingUrl(state),
  operatorSearchUrl: (getIsAdmin(state) && getOperatorSearchUrl(state)) || '',
});

export default connect(mapStateToProps)(OperatorInfo);
